<script lang="ts">
  import Tab, {Label} from '@smui/tab';
  import TabBar from '@smui/tab-bar';
  import Fa from 'svelte-fa/dist/svelte-fa';
	import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
	import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
	import { faSlidersH } from '@fortawesome/free-solid-svg-icons/faSlidersH';

	import Qn from './Qn.svelte'; 
	import Answer from './Answer.svelte'; 
  import Options from './Options.svelte';
  
  export let qnNumber: string;

  let icon1 = faQuestionCircle;
  let icon2 = faExclamationCircle;
  let icon3 = faSlidersH;

  let keyedTabs = [
    {
      k: 1,
      icon: icon1,
      label: 'Question'
    },
    {
      k: 2,
      icon: icon2,
      label: 'Answer'
    },
    {
      k: 3,
      icon: icon3,
      label: 'Options'
    }
  ];
  let keyedTabsActive = keyedTabs[0];
</script>

<section>
  <div style="width: 100%">
    <TabBar tabs={keyedTabs} let:tab key={tab => tab.k} bind:active={keyedTabsActive}>
      <Tab {tab} stacked={true} indicatorSpanOnlyContent={true} tabIndicator$transition="fade">
        <div style="font-size:2em">
          <Fa icon={tab.icon}></Fa>
        </div>
        <Label>{tab.label}</Label>
      </Tab>
    </TabBar>

    {#if keyedTabsActive.k == 1}
      <Qn {qnNumber}/> 
    {:else if keyedTabsActive.k == 2}
      <Answer/>
    {:else}
      <Options/>
    {/if}
  </div>
</section>
